import AttachmentError from './AttachmentError';

export default AttachmentError;
